import { format } from 'date-fns'
import React, { FC } from 'react'
import { IOrderTracking } from 'models/order/aggregates/tracking/IOrderTracking'
import "./OrderTracking.css"
import { TimeLineStatus } from './timeLineStatus/TimeLineStatus'
import { Button, Icon } from '@material-ui/core'
import QRCode from "qrcode.react";
import { useI18n } from 'utils/i18n/hooks/useI18n';
import { ICurrency } from 'models/local/ILocalConfig'


interface IOrderTrackingProps {
    orderTracking: IOrderTracking;
}

export const OrderTracking: FC<IOrderTrackingProps> = ({ orderTracking }) => {
    const { t } = useI18n();
    const currency = JSON.parse(localStorage.getItem(`@currency`) || '{}') as ICurrency;

    return (

        <div id="orderTracking">
            <div className="title">PEDIDO: #{orderTracking.Code}</div>
            <div id="content">
                <div id="info">

                    {/* <div>{orderTracking.Id}</div> */}
                    <div className="infoLabel">{t("orders.labels.createdAtTracking")} {format(new Date(orderTracking.CriationDate), "HH:mm dd/MM/yyyy")}</div>
                    {
                        orderTracking.AcceptDate &&
                        <div className="infoLabel">{t("orders.labels.acceptedAt")} {format(new Date(orderTracking.AcceptDate), "HH:mm dd/MM/yyyy")}</div>
                    }
                    <div className="infoLabel">{t("orders.labels.paymentType")} {orderTracking.KindPay}</div>
                    <div className="infoLabel">{t("orders.labels.orderValue")} {currency?.symbol ?? "R$"} {orderTracking.Amount.toFixed(2).replace(".", ",")}</div>
                    {!!orderTracking.Duration &&
                        <div className="infoLabel">{t("orders.labels.estimatedTime")} {orderTracking.Duration}</div>
                    }


                    <div>
                        <div className="infoLabel">
                            {t("orders.labels.order")}
                        </div>

                        <div className="pedidoItens">
                            {orderTracking.Items.map((item) => (
                                <div> {item.Quantidade} {item.NomeProduto} {item.Valor.toFixed(2).replace(".", ",")}</div>
                            ))}
                        </div>
                    </div>
                </div>

                <div>
                    <QRCode size={250} style={{ margin: 16 }} value={orderTracking.Id.replace(/[^0-9a-zA-Zs]/g, "")} />
                </div>
                <div className="timeline">
                    {<TimeLineStatus statusOrder={orderTracking?.CurrentState} />}
                    {
                        !!orderTracking.TrackingKey &&
                        <Button fullWidth className="trackinDeliveryButton" variant="outlined" color={"primary"} onClick={() => window.open(orderTracking.TrackingKey)}><Icon>room</Icon>{t("orders.buttons.trackDelivery")}</Button>
                    }
                </div>
            </div>
        </div>
    )
}
